import { render, staticRenderFns } from "./crudReport.vue?vue&type=template&id=3b15f50c&"
import script from "./crudReport.vue?vue&type=script&lang=js&"
export * from "./crudReport.vue?vue&type=script&lang=js&"
import style0 from "./crudReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports